import React, { useState } from "react";
import { api } from "@/lib/api";
import { StatCard, usePoll, fmtUSDT } from "@/components/common";

const LABELS = {
  deposit_credit: "Deposit credited", hold_reserve: "Reserved for order", hold_release: "Hold released",
  sale_finalize: "Sale finalized", manual_add: "Manual addition", manual_deduct: "Manual deduction",
  excess_inr_deduction: "Excess INR deduction",
};

export default function Wallet() {
  const [w, setW] = useState(null);
  const [ledger, setLedger] = useState([]);
  usePoll(() => {
    api.get("/customer/wallet").then((r) => setW(r.data)).catch(() => {});
    api.get("/customer/transactions").then((r) => setLedger(r.data)).catch(() => {});
  }, 7000, []);

  if (!w) return <div className="text-slate-400">Loading wallet…</div>;
  const deficit = parseFloat(w.deficit) > 0;

  return (
    <div className="space-y-6">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Wallet</h1>
      <div className="grid sm:grid-cols-3 gap-5">
        <StatCard testid="wallet-available-card" label="Available USDT" value={fmtUSDT(w.available)} tone="blue" />
        <StatCard testid="wallet-held-card" label="Held USDT" value={fmtUSDT(w.held)} tone="amber" />
        <StatCard testid="wallet-deficit-card" label="Deficit" value={fmtUSDT(w.deficit)} tone={deficit ? "rose" : "default"} />
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-5">
        <h2 className="font-heading font-semibold text-slate-900 mb-3">Ledger history</h2>
        {ledger.length === 0 ? <div className="text-sm text-slate-400 py-6 text-center">No movements yet</div> : (
          <div className="overflow-x-auto scrollbar-thin">
            <table className="w-full text-sm" data-testid="wallet-ledger-table">
              <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-400 border-b border-slate-200">
                <th className="py-2 pr-4">Type</th><th className="py-2 pr-4">Amount</th><th className="py-2 pr-4">After</th><th className="py-2 pr-4">Reason</th><th className="py-2">When</th>
              </tr></thead>
              <tbody>
                {ledger.map((t) => (
                  <tr key={t.id} className="border-b border-slate-100">
                    <td className="py-2.5 pr-4 font-medium text-slate-800">{LABELS[t.entry_type] || t.entry_type}</td>
                    <td className="py-2.5 pr-4 font-mono">{fmtUSDT(t.amount)}</td>
                    <td className="py-2.5 pr-4 font-mono text-slate-500">A {fmtUSDT(t.balance_after?.available)} · H {fmtUSDT(t.balance_after?.held)}{parseFloat(t.balance_after?.deficit) > 0 ? ` · D ${fmtUSDT(t.balance_after.deficit)}` : ""}</td>
                    <td className="py-2.5 pr-4 text-slate-500 max-w-xs truncate">{t.reason}</td>
                    <td className="py-2.5 text-slate-400 whitespace-nowrap">{new Date(t.timestamp).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
